export default __webpack_public_path__ + "static/O0310-9f686de207e2a83f3bd17371ae260fab.png";